import "../../index42.css";
import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { a as r } from "../../core-DVmjA3_O.js";
import { _ as v } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import z from "../Spinner/index.js";
const u = "_message_szdc0_1", x = "_icon_szdc0_13", D = "_spinner_szdc0_18", j = "_title_szdc0_24", w = "_errored_szdc0_30", T = "_compact_szdc0_36", s = {
  message: u,
  icon: x,
  spinner: D,
  title: j,
  errored: w,
  compact: T
};
function A(l) {
  const {
    className: p,
    pending: c = !1,
    variant: _,
    icon: o,
    title: t,
    description: n,
    actions: a,
    compact: f = !1,
    errored: i,
    erroredTitle: d,
    erroredDescription: h
  } = l, N = i ? r(d) : r(t), g = i ? r(h) : r(n);
  return /* @__PURE__ */ m(
    "div",
    {
      className: v(
        s.message,
        _ === "error" && s.errored,
        f && s.compact,
        p
      ),
      children: [
        (o || c) && /* @__PURE__ */ m("div", { className: s.icon, children: [
          c && /* @__PURE__ */ e(z, { className: s.spinner }),
          !c && o
        ] }),
        N && /* @__PURE__ */ e("div", { className: s.title, children: i ? d : t }),
        g && /* @__PURE__ */ e("div", { className: s.description, children: n }),
        a && /* @__PURE__ */ e("div", { className: s.actions, children: a })
      ]
    }
  );
}
export {
  A as default
};
